import { o2oApi } from 'yxt-biz-pc/packages/api';
import qs from 'qs';

export const getEvaluateList = (projectId, availableFlag) => {
  return o2oApi.get(`/study/stu/evaluate/list?${qs.stringify({ projectId, availableFlag })}`);
};

export const getEvaluateIsEnable = (projectId, taskId) => {
  return o2oApi.get(`/study/stu/check/can/evaluate?${qs.stringify({ projectId, taskId })}`);
};

// 简单项目详情
export const getSimpleProjectInfo = (projectId) => {
  return o2oApi.get(`/study/stu/project/baseinfo/${projectId}`);
};
